import { Link, useLocation } from "react-router-dom";

const LABELS: Record<string, { hint: string; cta: string; to: string }> = {
  "/fuer-anbieter": { hint: "Als Liftanbieter Anfragen aus Ihrer Region erhalten.", cta: "Anbieter werden", to: "/fuer-anbieter#kontakt" },
  "/kontakt": { hint: "Lieber direkt Ihr Projekt erfassen?", cta: "Anfrage starten", to: "/wizard" },
  "/liftarten": { hint: "Passende Liftart gefunden? Projekt jetzt erfassen.", cta: "Anfrage starten", to: "/wizard" },
  "/faq": { hint: "Frage geklärt? Projekt in wenigen Minuten erfassen.", cta: "Anfrage starten", to: "/wizard" },
};

const DEFAULT = { hint: "Liftprojekt erfassen, Anbieter melden sich direkt.", cta: "Anfrage starten", to: "/wizard" };

/**
 * Fest sitzender Handlungsaufruf auf schmalen Viewports.
 * Auf Desktop unsichtbar, dort übernimmt der Header-CTA.
 */
export function StickyMobileCta() {
  const { pathname } = useLocation();
  const { hint, cta, to } = LABELS[pathname] ?? DEFAULT;

  return (
    <div className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 backdrop-blur-sm">
      <div
        className="flex items-center gap-3 px-4 py-3"
        style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      >
        <p className="flex-1 text-[12.5px] leading-[1.35] text-muted-foreground">{hint}</p>
        <Link
          to={to}
          className="inline-flex h-11 shrink-0 items-center rounded-sm bg-primary px-5 text-[14px] font-medium text-primary-foreground transition-transform active:scale-[0.98]"
        >
          {cta}
        </Link>
      </div>
    </div>
  );
}

